import React, { useState } from 'react';
import Button from '@mui/material/Button';
import { Alert, Box } from '@mui/material';
import { CircularProgress } from "@mui/material";

import GestioneDellaSalute from '../Components/AccertamentoInfermieristico/GestioneDellaSalute';
import AccertamentoNutrizione from '../Components/AccertamentoInfermieristico/AccertamentoNutrizione';
import CuteMucose from '../Components/AccertamentoInfermieristico/CuteMucose';
import AccertamentoEliminazione from '../Components/AccertamentoInfermieristico/AccertamentoEliminazione';
import Riposo from '../Components/AccertamentoInfermieristico/Riposo';
import ModelloCognitivo from '../Components/AccertamentoInfermieristico/ModelloCognitivo';
import Sensi from '../Components/AccertamentoInfermieristico/Sensi';
import { useSubmitAccertamento } from '../Hooks/useSubmitAccertamento';
import ReportNANDA from '../Components/ReportNanda';

function AccertInfermOrchestrator() {
  const [step, setStep] = useState(0);
  const [parameters, setParameters] = useState({});

  const componentList = [
    GestioneDellaSalute,
    AccertamentoNutrizione,
    CuteMucose,
    AccertamentoEliminazione,
    Riposo,
    ModelloCognitivo,
    Sensi,
  ];

  const { submit, report, setReport, loading, error } = useSubmitAccertamento();


  return (
    <div>
      {componentList.map((Component, index) => {
        return (
          <div
            key={index}
            style={{ display: step === index ? 'block' : 'none' }}
          >
            <Component parameters={parameters} setParameters={setParameters} />
          </div>
        );
      })}

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          mt: 3,
          gap: 2,
        }}
      >
        {step > 0 && (
          <Button variant="outlined" onClick={() => setStep(step - 1)}>
            Precedente
          </Button>
        )}

        {step < componentList.length - 1 && (
          <Button variant="contained" onClick={() => setStep(step + 1)}>
            Successivo
          </Button>
        )}

        <Button variant="contained" onClick={() => console.log(parameters)}>
          Log
        </Button>

        <Button onClick={() => submit(parameters)} disabled={loading}>
          {loading ? 'Elaborazione...' : 'Invia accertamento'}
        </Button>
      </Box>

      <Box margin={10} maxWidth={'50ch'}>
        {error && <Alert severity="error">{error}</Alert>}
      </Box>

      {/* Overlay caricamento */}
        {loading && (
          <Box
            sx={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              bgcolor: 'rgba(0,0,0,0.6)',
              zIndex: 2000,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              color: 'white',
            }}
          >
            <CircularProgress color="inherit" />
            <Box sx={{ mt: 2 }}>
              Attendi mentre genero i risultati
            </Box>
          </Box>
        )}

      {/* Overlay ReportNANDA */}
        {report && (
        <Box
            sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            bgcolor: 'rgba(0,0,0,0.6)',
            zIndex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            }}
        >
            <Box
            sx={{
                bgcolor: 'background.paper',
                borderRadius: 2,
                p: 4,
                maxHeight: '90%',
                overflowY: 'auto',
                boxShadow: 24,
                width: '90%',
                maxWidth: '55ch',
            }}
            >

            <ReportNANDA report={report} />
            {/* Bottone Chiudi rosso e centrato */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <Button
                variant="contained"
                color="error"
                onClick={() => setReport(null)} 
                >
                Chiudi
                </Button>
            </Box>
            </Box>
        </Box>
        )}
    </div>
  );
}

export default AccertInfermOrchestrator;